import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { DeactivateCustomPriceInput, DeactivateCustomPricePayload } from "@oysterhr/schema"

export const DEACTIVATE_CUSTOM_PRICE = gql`
  mutation DeactivateCustomPrice($planPriceId: String!, $companyId: String!) {
    deactivateCustomPrice(input: { planPriceId: $planPriceId, companyId: $companyId }) {
      planPrice {
        id
        deactivatedOn
      }
      errors
    }
  }
`

export default (
  options?: InjectedOptions<
    { deactivateCustomPrice: DeactivateCustomPricePayload },
    DeactivateCustomPriceInput
  >,
) => useMutation(DEACTIVATE_CUSTOM_PRICE, { ...options })
